// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#captcha-button {\r\n  z-index: 99;\r\n  width: 150px;\r\n  box-sizing: border-box;\r\n  border-radius: 4px;\r\n  border: 1px solid transparent;\r\n  cursor: pointer;\r\n  color: #fff;\r\n  padding: 8px 0;\r\n  font-size: 14px;\r\n  line-height: 22px;\r\n  text-align: center;\n}\r\n", ""]);
// Exports
module.exports = exports;
